/**
 * Model used to represent a single wizard step
 */
export class WizardStep {
    public name: string;
    public isVisible: boolean;
    public routeName: string;
    public routeParams: string[];

    /**
     * Represents if this step is active or not
     */
    get isActive(): boolean {
        const pathArray: string[] = location.pathname.split('/');

        if (!this.routeName && pathArray.length <= 4) {
            return true;
        }

        return pathArray.filter(
            (path: string, idx: number) => idx > 2 && path === this.routeName,
        ).length > 0;
    }

    /**
     * Constructor
     */
    constructor(name: string, routeName: string, routeParams: string[], isVisible: boolean) {
        this.name = name;
        this.routeName = routeName;
        this.routeParams = routeParams;
        this.isVisible = isVisible;
    }
}
